import React, { useState } from 'react';
import { Segment, Button, Form, List, Input, Grid, Checkbox } from 'semantic-ui-react';

const DailyNotes = () => {
  const [notes, setNotes] = useState([]);
  const [currentNote, setCurrentNote] = useState('');
  const [manualTime, setManualTime] = useState('');
  const [editMode, setEditMode] = useState(false); // ✅ single toggle for showing delete buttons

  const handleAddNote = () => {
    if (!currentNote.trim()) return;

    const timestamp =
      manualTime || new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    setNotes(prev => [...prev, { time: timestamp, text: currentNote }]);
    setCurrentNote('');
    setManualTime('');
  };

  const handleDeleteNote = (index) => {
    setNotes(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <Segment
      basic
      style={{
        padding: '15em',
        backgroundColor: '#f5f5f5',
        minHeight: '90vh',
        fontSize: '18px'
      }}
    >
      <Grid centered>
        <Grid.Row style={{ padding: 0 }}>
          <div
            style={{
              maxWidth: '600px',
              width: '100%',
              backgroundColor: 'white',
              borderRadius: '10px',
              padding: '1em',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              fontSize: '18px',
              color: '#555'
            }}
          >
            <h2 style={{ textAlign: 'center', fontSize: '18px' }}>Daily Notes</h2>

            <div style={{ textAlign: 'left', marginBottom: '1em' }}>
              <ul style={{ paddingLeft: '20px', margin: 0 }}>
                <li>Single word actions, feelings, or events such as "exercise", "sleep", "meeting", "relaxed", etc.</li>
                <li>Or phrases like "meeting with board", "traveled on bus".</li>
                <li>Can also use keyboard icons like "😊", "🏃‍♂️", "🛌", "😟", etc.</li>
                <li>If emotional state, try to note events that may have contributed, e.g., "anxiety - work deadline", "anger - met with Roger".</li>
                <li>Abbreviations are fine.</li>
              </ul>
            </div>

            {/* Input Section */}
            <Form onSubmit={e => { e.preventDefault(); handleAddNote(); }}>
              <Form.Field>
                <label style={{ fontSize: '18px' }}>Manual Time (optional)</label>
                <Input
                  type="time"
                  value={manualTime}
                  onChange={e => setManualTime(e.target.value)}
                  style={{ marginBottom: '0.5em', fontSize: '18px' }}
                />
              </Form.Field>
              <Form.Field>
                <label style={{ fontSize: '18px' }}>Note</label>
                <Input
                  placeholder="Write your note..."
                  value={currentNote}
                  onChange={e => setCurrentNote(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleAddNote()}
                  style={{ fontSize: '18px' }}
                />
              </Form.Field>

              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '0.5em'
              }}>
                <Button color="#302d4a" type="submit" style={{ fontSize: '18px' }}>
                  Add Note
                </Button>

                {/* ✅ Single toggle radio for Edit Mode */}
                <Checkbox
                  toggle
                  checked={editMode}
                  label="Edit Notes"
                  onChange={() => setEditMode(!editMode)}
                  style={{ fontSize: '18px' }}
                />
              </div>
            </Form>

            {/* Notes List */}
            {notes.length > 0 && (
              <Segment basic style={{ padding: '1em 0 0 0' }}>
                <List divided relaxed>
                  {notes.map((note, index) => (
                    <List.Item
                      key={index}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0.3em 0',
                        fontSize: '18px'
                      }}
                    >
                      <div style={{ flex: 1, marginRight: '1em', textAlign: 'left' }}>
                        <strong>{note.time}</strong> — {note.text}
                      </div>
                      {editMode && (
                        <Button
                          size="mini"
                          color="red"
                          onClick={() => handleDeleteNote(index)}
                          style={{ fontSize: '16px' }}
                        >
                          Delete
                        </Button>
                      )}
                    </List.Item>
                  ))}
                </List>
              </Segment>
            )}
          </div>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default DailyNotes;
